/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Content } from './Content';
import { ContentFromJSON, ContentFromJSONTyped, ContentToJSON } from './Content';
import type { Html } from './Html';
import { HtmlFromJSON, HtmlFromJSONTyped, HtmlToJSON } from './Html';
import type { Title } from './Title';
import { TitleFromJSON, TitleFromJSONTyped, TitleToJSON } from './Title';
import type { Type } from './Type';
import { TypeFromJSON, TypeFromJSONTyped, TypeToJSON } from './Type';

/**
 *
 * @export
 * @interface ArticleUpdateModel
 */
export interface ArticleUpdateModel {
    /**
     *
     * @type {Title}
     * @memberof ArticleUpdateModel
     */
    title?: Title;
    /**
     *
     * @type {Content}
     * @memberof ArticleUpdateModel
     */
    content?: Content;
    /**
     *
     * @type {Html}
     * @memberof ArticleUpdateModel
     */
    html?: Html;
    /**
     *
     * @type {Type}
     * @memberof ArticleUpdateModel
     */
    type?: Type;
    /**
     *
     * @type {string}
     * @memberof ArticleUpdateModel
     */
    createdAt?: string;
}

/**
 * Check if a given object implements the ArticleUpdateModel interface.
 */
export function instanceOfArticleUpdateModel(value: object): boolean {
    return true;
}

export function ArticleUpdateModelFromJSON(json: any): ArticleUpdateModel {
    return ArticleUpdateModelFromJSONTyped(json, false);
}

export function ArticleUpdateModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ArticleUpdateModel {
    if (json == null) {
        return json;
    }
    return {
        title: json['title'] == null ? undefined : TitleFromJSON(json['title']),
        content: json['content'] == null ? undefined : ContentFromJSON(json['content']),
        html: json['html'] == null ? undefined : HtmlFromJSON(json['html']),
        type: json['type'] == null ? undefined : TypeFromJSON(json['type']),
        createdAt: json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function ArticleUpdateModelToJSON(value?: ArticleUpdateModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        title: TitleToJSON(value['title']),
        content: ContentToJSON(value['content']),
        html: HtmlToJSON(value['html']),
        type: TypeToJSON(value['type']),
        created_at: value['createdAt'],
    };
}
